import { render, staticRenderFns } from "./NotTurPicker.vue?vue&type=template&id=d851b5b0"
import script from "./NotTurPicker.vue?vue&type=script&lang=ts"
export * from "./NotTurPicker.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports